import { useMemo } from 'react'
import { Button, CardInfo, getCDNUrl, useMonetization } from '@shared'

import styles from './NewQuestPopup.module.scss'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useOverlayActions } from '@store'
import { useAudio } from '@providers'
import classNames from 'classnames'

interface PopupProps {
  questSlug: string
}

export const NewQuestPopup = ({ questSlug }: PopupProps) => {
  const { showAd, isLoading, dailyLimit } = useMonetization('unlock_quest', 'adsgram')
  const { hideOverlay } = useOverlayActions()
  const { playSwitchOff } = useAudio()

  const { t } = useTranslation()
  const navigate = useNavigate()
  const cardInfo = useMemo(() => {
    return {
      url: getCDNUrl("/assets/newQuest/Play.png"),
      effects: {},
      title: t('popup.newQuest.title'),
      description: t('popup.newQuest.description')
    }
  }, [t])

  const limit = useMemo(() => {
    if (!dailyLimit) return '';
    const left = Math.max(0, dailyLimit.limit - dailyLimit.used);
    return `${left}/${dailyLimit.limit} available`;
  }, [dailyLimit]);

  const disabled = useMemo(() => {
    if (!dailyLimit) return false;
    return dailyLimit.used >= dailyLimit.limit;
  }, [dailyLimit]);

    
  return (
    <CardInfo
      url={cardInfo.url}
      effects={cardInfo.effects}
      onClose={hideOverlay}
      title={cardInfo.title}
      description={cardInfo.description}
      className={styles.cardInfo}
    >
      <div className={styles.buttons}>
          <Button
            icon="shop"
            onClick={() => {
              navigate('/battle-pass')
              hideOverlay()
            }}
          >
            {t('popup.newQuest.buyBattlePass')}
        </Button>
        <Button
          className={classNames(styles.adButton, {
            [styles["adButton__disabled"]]: disabled
          })}
          icon="crypto"
          isLoading={isLoading}
          onClick={() => {
            if (disabled) return;
            showAd(questSlug, () => {
              playSwitchOff()
              navigate(`/quest/${questSlug}`)
              hideOverlay()
            })
          }}
        >
          {t('popup.newQuest.showAd')}
        </Button>

        <div
          className={classNames(styles.limit, {
            [styles["limit__disable"]]: disabled,
          })}
        >
          {limit}
        </div>
      </div>
    </CardInfo>
  )
}
